import Language from '../Language'

export default new Language(
  'Icelandic',
  ['Janúar', 'Febrúar', 'Mars', 'Apríl', 'Maí', 'Júní', 'Júlí', 'Ágúst', 'September', 'Október', 'Nóvember', 'Desember'],
  ['Jan', 'Feb', 'Mars', 'Apr', 'Maí', 'Jún', 'Júl', 'Ágú', 'Sep', 'Okt', 'Nóv', 'Des'],
  ['Sun', 'Mán', 'Þri', 'Mið', 'Fim', 'Fös', 'Lau']
)

  ;
